import { Customer } from "../../commercelayer/vo/customers";

export const customerIsDistributor = function (customer: Customer | null): boolean {
  if (customer === null) {
    return false;
  }

  return customer.attributes?.metadata["s_dbt_sal-kalks"] === "1";
};
